<template>
    <div v-if="show" class="mb-5 flex items-center justify-between border" :class="styles">
        <div class="flex items-center">
            <div class="py-2 pl-4 text-sm font-medium" v-html="display"></div>
        </div>
        <button type="button" class="group mr-2 p-2 fill-white" @click="reset">
            <svg class="block w-2 h-2 text-white" xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908" viewBox="278.046 126.846 235.908 235.908"><path d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" /></svg>
        </button>
    </div>
</template>

<script>
export default {
    name: "FlashMessage",
    props: {
        type: String,
        message: [String, Array]
    },
    data() {
        return {
            show: true
        }
    },
    methods: {
        reset() {
            this.show = false;
            this.$emit('reset');
        }
    },
    computed: {
        styles() {
            return {
                'bg-green-600 text-white': this.type === 'success',
                'bg-blue-600 text-white': this.type === 'info',
                'bg-red-600 text-white': this.type === 'error'
            }
        },
        display() {
            if (typeof this.message === 'string') {
                return this.message;
            }
            if (this.message.length === 1) {
                return this.message[0];
            }
            return '- ' + this.message.join("<br/>- ");
        }
    },
    watch: {
        message() {
            this.show = true;
        }
    }
}
</script>
